var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71443 4.1626H12.3373C12.6325 4.1626 12.8686 4.40793 12.8573 4.70292L12.442 15.4997C12.4313 15.7791 12.2017 16 11.9221 16H2.18901C1.91053 16 1.68142 15.7807 1.66919 15.5025L1.19461 4.70578C1.18159 4.40973 1.4181 4.1626 1.71443 4.1626Z",
    fill: "#003393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.82114C0 1.39009 0.349436 1.04065 0.780488 1.04065H13.0081C13.4392 1.04065 13.7886 1.39009 13.7886 1.82114V2.60163C13.7886 2.88899 13.5557 3.12195 13.2683 3.12195H0.520325C0.232957 3.12195 0 2.88899 0 2.60163V1.82114Z",
    fill: "#003393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90244 0.780488C3.90244 0.349436 4.25188 0 4.68293 0H8.84553C9.27658 0 9.62602 0.349436 9.62602 0.780488V1.04065H3.90244V0.780488Z",
    fill: "#003393"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ac2c24b42b62d4fd3e01666c88a84a5d.svg";
export { ForwardRef as ReactComponent };